/**
 * Created by Farrukh Ahmed on 2/26/2016.
 */
(function(){
    angular.module('tmx-app').service('BiztalkRulesService', ['$http','APP_CONSTANTS',

        function BiztalkRuleService($http,APP_CONSTANTS) {

            var service = this;

            service.verifyLoanApplication=function(data,callback){
                return $http.post(APP_CONSTANTS.backend +"BizTalkKSS/VerifyRules",data).then(callback);
            }
        }]);


})();